export const TOOLTIP_TEXT_FIRST_PARA =
  'Your broadband number is your unique broadband service number which starts with 8881, 8882 or 8883 which will show on your bill.';
export const TOOLTIP_TEXT_SECOND_PARA =
  'If you do not have a broadband number, please enter your existing home phone number.';
export const VALIDATION_TEXT = {
  eircodeValidation: 'Please, enter a valid Eircode.',
  phoneNumberValidation: 'Please, enter a valid phone number.',
  eircodeRequired: 'Please, enter your eircode.',
};
export const PREQUAL_FAILED_TITLE = "Sorry, we can't find this eircode";
export const PREQUAL_FAILED_DESCRIPTION_PRE = 'We have checked ';
export const PREQUAL_FAILED_DESCRIPTION_POST =
  ', Please enter your broadband or phone number to check availability';
export const USE_PHONENUMBER_TEXT = {
  text: 'Use my',
  urlText: 'Eircode instead',
};
export const NOT_ELLIGIBLE = 'Not Eligible';
export const ECC =
  'You are in contract with your current broadband, why not look at upgrading your package';

export const SERVICE_DOMAINS = {
  FIXED: 'FIXED', // deprecated
  BROADBAND: 'BROADBAND', // deprecated
  VOBB: 'VOBB', // deprecated
  TV: 'TV', // deprecated
  MOBILE: 'MOBILE',
  MBB: 'MBB',
  PSTN: 'PSTN',
  VOIP: 'VOIP',
  FIBER: 'FIBER',
  IPTV: 'IPTV',
  DSL: 'DSL',
};
export const SERVICE_GROUPS = {
  MOBILE: 'MOBILE',
  MBB: 'MBB',
  TV: 'TV',
  DUALPLAY: 'DUALPLAY',
  SA_PSTN: 'SA_PSTN',
  DUALPLAY_PSTN: 'DUALPLAY_PSTN',
};

export const MODAL_ID = {
  NBI_ORDER_PENDING: 'nbi-order-pending',
  NBI_ORDER_RESERVED: 'nbi-order-reserved',
  NBI_INTERVENTION_AREA: 'nbi-intervention-area',
  NBI_SURVEY_REQUIRED: 'nbi-survey-required',
  NBI_ACTIVE_LINES: 'nbi-active-lines',
  NBI_MULTIPLE_PREMISES: 'nbi-multiple-premises',
};

export const BROADBAND_TECHNOLOGY = {
  NBI: 'NBI',
  FTTH: 'FTTH',
  FTTC: 'FTTC',
  NGB: 'NGB',
};

export const CART_TYPE = {
  NEW_ACQUISITION: 'NEW_ACQUISITION',
  CROSS_SELL: 'CROSS_SELL',
  CHANGE_OFFER: 'CHANGE_OFFER',
};

export const CHANNEL = {
  ESHOP: 'ESHOP',
  MYEIR: 'MYEIR',
  RETAIL: 'RETAIL',
};

export const INSTALLATION_TYPE = {
  FULL_INSTALL: 'FULL_INSTALL',
  TECH_INSTALL: 'TECH_INSTALL',
  SELF_INSTALL: 'SELF_INSTALL',
  NO_INSTALL: 'NO_INSTALL',
};

export const OTHER_SERVICE_PROVIDERS = {
  DIGIWEB: 'DIGIWEB',
  IFA: 'IFA',
  IMAGINE: 'IMAGINE',
  PURE: 'PURE',
  VODAFONE: 'VODAFONE',
  SKY: 'SKY',
  VIRGINMEDIA: 'VIRGIN MEDIA',
};

/* Product Names defined in Strapi */
export const CART_ITEM = {
  BB: 'BB', // Broadband
  BB_TECH: 'BB_TECH', //  Broadband Tech Install
  BB_SELF: 'BB_SELF', // Broadband Self Install
  BB_TV: 'BB_TV', // Broadband + TV
  BB_TECH_TV: 'BB_TECH_TV', // Broadband Tech Install + TV
  BB_SELF_TV: 'BB_SELF_TV', // Broadband Self Install + TV
  BB_NBI: 'BB_NBI', // NBI
  BB_MOBILE: 'BB_MOBILE', // Broadband + MOBILE
  BB_NBI_MOBILE: 'BB_NBI_MOBILE', // NBI + MOBILE
  TV_MOBILE: 'TV_MOBILE', // TV + MOBILE
};

export const CHECKOUT_STEPS = {
  CUSTOMER_PROFILE: 'customer-profile',
  INSTALLATION: 'installation',
  PAYMENT: 'payment',
};

/* Payment Gateway Provider */
export const PAYMENT_GATEWAY_SELECTOR = {
  ELAVON: 'ELAVON',
  STANCER: 'STANCER',
};

/* Payment Provider for checkout */
export const PAYMENT_PROVIDER = {
  ELAVON: 'ELAVON',
  STANCER_UPFRONT: 'STANCER_UPFRONT',
  STANCER_RECURRING: 'STANCER_RECURRING',
  IBAN: 'IBAN',
  NO_PAYMENT: 'NO_PAYMENT',
};

/* Stancer payment origin */
export const PAYMENT_STANCER_URL = 'https://payment.stancer.com';

export const PAYMENT_METHOD_TYPE = {
  CREDIT_CARD: 'CREDIT_CARD',
};

/* Stancer payment processing status */
export const STANCER_PAYMENT_STATUS = {
  ERROR: 'error',
  INIT: 'init',
  INVALID: 'invalid	',
  FINISHED: 'finished',
  PENDING: 'pending',
  SECURE_AUTH_END: 'secure-auth-end',
  SECURE_AUTH_ERROR: 'secure-auth-error',
  SECURE_AUTH_START: 'secure-auth-start',
};

export const RECAPTCHA_KEY_V3 = '6Le2qgUqAAAAABvwuaR9zreIQJqB9R6_TIozGGHQ';

export const ACTIONS = {
  GENERIC_REDIRECT: 'GENERIC_REDIRECT',
  GENERIC_CALL_DIALER: 'GENERIC_CALL_DIALER',
};

export const BANNER_BACKGROUND = {
  DARK: 'dark',
  LIGHT: 'light',
};

export const OFFER_TYPE_CODE = {
  PREPAY: 'PREPAY',
  POSTPAY: 'POSTPAY',
};

export const ADDON_ITEM_GROUP = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  DISCOUNTS: 'DISCOUNTS',
};

export const ACCOUNT_TYPES = {
  BILL_PAY_SINGLE_LINE: 'BILL_PAY_SINGLE_LINE',
  BILL_PAY_MULTI_LINE: 'BILL_PAY_MULTI_LINE',
  PAYG_REGISTERED: 'PAYG_REGISTERED',
  PAYG_UNREGISTERED: 'PAYG_UNREGISTERED',
  PAYG_MULTI_LINE: 'PAYG_MULTI_LINE',
};
